import React, { Component } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import './prof.css'

export default class Prof extends Component {

  render() {
    const description = '年間1000本以上のパイズリ挟射動画を10年以上見続けてきた挟射マニアが、個人的にオススメのパイズリ挟射動画をまとめています。パイズリ挟射のない作品は紹介しません'
    return (
      <div className='prof'>
        <p className='heading'>プロフィール</p>
        <div className='prof_contents'>
          <div className='prof_img'>
            <StaticImage
              className="bio-avatar"
              layout="fixed"
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/av-prof-icon.png"
              width={110}
              height={110}
              style={{ borderRadius: "50%", zIndex: "1" }}
              alt="Profile picture"
            />
          </div>
          <p className='profile_name'>
            <a href="https://twitter.com/pailovetokyo" target="_blank" rel="noreferrer">PZ研究家</a>
          </p>
          <p className='prof_description'>{description}→ <span className='prof_link'><Link to={`/profile/`}>当ブログの趣旨はコチラ</Link></span></p>
          <div className='prof_ranking'>
            <p className='ranking_lecture'>参加しているランキングサイト</p>
            <p>・<a href="http://www.adultblogranking.com/link/?id=2089650" target="_blank" without rel="noreferrer">アダルトブログランキング</a></p>
            <p>・<a href="https://blogranking.fc2.com/in.php?id=1061209" target="_blank" without rel="noreferrer">FC2ブログランキング</a></p>
          </div>
        </div>
      </div>
    )
  }
}